"use client";
import React, { Suspense, memo } from "react";
import UserInfo from "../UserInfo";
import MobileCategory from "../MobileCategory";
import { Box } from "@dxp-feed/ui/Box";
import { SiteContainer } from "../../Container";
import { Search } from "../Search/GlobalSearch";
import { StoreLocator } from "../StoreLocator";

import Loader from "../../Loader";

const MobileNavigationBar = ({
  headerData,
  searchStaticAEMData,
  mobileMedia,
}: any) => {
  return (
    <>
      <Box
        className={`block lg:hidden mobile-show relative bg-brandWhite  border-b-[1px] border-grey350`}
      >
        <SiteContainer className="px-6 2md:px-12">
          <Box className="flex-1 hidden tab-search  [&_.dropDown]:z-[99999] md:block lg:hidden pt-[12px]  z-[9]">
            {mobileMedia && mobileMedia <= 1023 && (
              <Suspense fallback={<Loader />}>
                <Search
                  placeholder={headerData["header"]?.searchplaceholder}
                  className="search-tablet-view [&_.inputWrapper]:!z-0"
                  searchStaticAEMData={searchStaticAEMData}
                />
              </Suspense>
            )}
          </Box>
          {mobileMedia && mobileMedia <= 1023 && (
            <Box className="flex justify-between items-center lg:hidden py-[8px] md:pt-[10px] md:pb-3">
              <StoreLocator />
              <Box className="flex lg:hidden">
                <UserInfo />
              </Box>
            </Box>
          )}
        </SiteContainer>
        <Box>
          <Box
            as="div"
            className={
              "top-header-action-icons py-[12px] md:hidden bg-brandWhite border-t-[1px] border-grey350"
            }
          >
            <MobileCategory />
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default memo(MobileNavigationBar);
